import * as req from 'api/actions';
import * as c from './constant';

export const getOrdinanceRevisionEffectivity = (payload, callback) =>
req.list(
  c.GET_ORDINANCE_REVISION_EFFECTIVITY,
  `/api/v1/bpls/administrator/common/ordinance_revisions`,
  payload,
  callback
);

// dummy
export const dummy = (payload, callback) =>
req.list(
  c.GET_ORDINANCE_REVISION_EFFECTIVITY,
  `/api/v1/bpls/administrator/common/ordinance_revisions`,
  payload,
  callback
);

export const getReports = (payload, callback) =>
  req.create(
    c.GET_REPORTS,
    'api/v1/bpls/administrator/report/distribution_report_by_revenue_account/generate',
    payload,
    callback
  );

export const getReportList = (payload, callback) => 
req.list(
  c.GET_REPORT_LIST,
  'api/v1/administrators/report_file_exports',
  payload,
  callback
);

export const getPreviewLink = (id, payload, callback) => 
req.item(
  c.GET_PREVIEW_LINK,
  `api/v1/administrators/report_file_exports_download/${id}/preview?bearer_token=${payload.bearer_token}&email=${payload.email}&`,
  callback
);

export const getRevenueReportList = (payload, callback) => 
  req.list(
    c.GET_REVENUE_REPORT_LIST,
    'api/v1/administrators/report_file_exports',
    payload,
    callback
  );
